var PubSub = (function () {
    function PubSub() {
        this.subscriptions = [];
    }
    PubSub.prototype.subscribe = function (callback) {
        var _this = this;
        var subscriptionId = this.subscriptions.length++;
        this.subscriptions.push({
            id: subscriptionId,
            callback: callback,
        });
        return function () {
            _this.subscriptions = _this.subscriptions.filter(function (_a) {
                var id = _a.id;
                return id !== subscriptionId;
            });
        };
    };
    PubSub.prototype.publish = function (eventName, meta) {
        if (meta === void 0) { meta = {}; }
        this.subscriptions.forEach(function (_a) {
            var callback = _a.callback;
            return callback(eventName, meta);
        });
    };
    return PubSub;
}());
export default PubSub;
